<template>
    <div class="borderConfig chartConfig_viewDP">
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.border.show" @change="getRender">是否展示边框</el-checkbox>
        </div>
        <div class="chartDivConfig selViewConfig minInput">
            <span class="span_til">边框</span>
            <el-select v-model="config.border.index" placeholder="请选择边框"
                       :popper-append-to-body="false" @change="getBorder">
                <el-option label="自定义" value="自定义"></el-option>
                <el-option :label="'边框'+(index+1)" :value="index" v-for="(item,index) in list"></el-option>
            </el-select>
        </div>

        <div class="chartDivConfig numViewConfig numViewConfig_unit minInput">
            <span class="span_til">宽度</span>
            <el-input v-model="config.border.width" type="number" min="0" @change="getRender"></el-input>
            <div class="unit">px</div>
        </div>

        <div class="chartDivConfig numViewConfig numViewConfig_unit minInput" v-if="config.border.index==='自定义'">
            <span class="span_til">圆角</span>
            <el-input v-model="config.border.radius" type="number" min="0" @change="getRender"></el-input>
            <div class="unit">px</div>
        </div>

        <div class="chartDivConfig selViewConfig minInput" v-if="config.border.index==='自定义'">
            <span class="span_til">样式</span>
            <el-select v-model="config.border.style" placeholder="请选择背景"
                       :popper-append-to-body="false" @change="getRender">
                <el-option label="直线" value="solid"></el-option>
                <el-option label="虚线" value="dashed"></el-option>
                <el-option label="点线" value="dotted"></el-option>
            </el-select>
        </div>

        <div class="chartDivConfig colViewConfig" v-if="config.border.index==='自定义'">
            <span class="span_til">颜色</span>
            <el-color-picker v-model="config.border.color" show-alpha @change="getRender"></el-color-picker>
        </div>


    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/5/25 4:01 下午
     */
    import {borderList} from '../../script/comChart'

    export default {
        name: 'borderConfig',
        components: {},
        props: {},
        computed: {
            config() {
                return this.$store.state.designer.chart.comConfig;
            },
        },
        data() {
            return {
                list: borderList,
            }
        },
        methods: {
            getRender() {
                this.$store.dispatch('screenRender');
            },
            getBorder() {
                if (this.config.border.index === '自定义') {
                    this.config.border.width = 1;
                } else {
                    this.config.border.width = 20;
                }
                this.getRender();
            },
        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .borderConfig {
        .minInput {
            > span {
                width: 40px;
            }

            > .el-input {
                width: 50%;
            }

            > .el-select {
                width: 50%;
            }
        }
    }
</style>